export const AnalyticsDashboardStatePath = 'analytics-dashboard';
